import { ScrollBarSize } from './CustomScrollBar.types';


export const scrollBarSizes: Record<ScrollBarSize, number> = {
  [ScrollBarSize.Small]:  5,
  [ScrollBarSize.Medium]: 10,
  [ScrollBarSize.Large]:  15,
};